/**
 * 描述：租户管理--领域热点
 * 日期：2019-9-3
 * 作者：zhaoqing
 */
'use strict';
angular.module('territoryPointModule', []).controller('territoryPointCtrl', [
    '$scope',
    'trsspliceString',
    '$q',
    '$filter',
    'tManageMentService',
    'modalDialog',
    'trsHttpService',
    function(
        $scope,
        trsspliceString,
        $q,
        $filter,
        tManageMentService,
        modalDialog,
        trsHttpService
    ) {
        // token 租户id
        var token = '',
            tenantId = '';

        $scope.status = {
            isTenantAdmin: false
        };

        $scope.data = {
            selectedArray: [],
            tenants: []
        };

        // $scope.page = {
        //     CURRPAGE: 1,
        //     ITEMCOUNT: 131,
        //     PAGECOUNT: 7,
        //     PAGESIZE: 50
        // }

        // 判断用户 管理员/租户
        function isTenantAdmin() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_extuser',
                methodName: 'isAdministrator'
            };
            trsHttpService
                .httpServer(trsHttpService.getWCMRootUrl(), params, 'post')
                .then(function(data) {
                    $scope.status.isTenantAdmin = data.ISADMINISTRATOR;
                    deffer.resolve();
                });
            return deffer.promise;
        }

        // 获取列表
        function getList() {
            $scope.loadingPromise = trsHttpService
                .httpServer(
                    '/api/tenantcenter/fieldhotpot/findAllFieldHots',
                    { tenantId: tenantId },
                    'post',
                    '',
                    { token: token }
                )
                .then(function(data) {
                    console.log(data);
                    if (data.code !== '200') {
                        return;
                    }
                    $scope.data.tenants = data.datas;
                    // $scope.data.selectedArray = data.datas.filter(item => item.status === '已绑定');
                });
        }
        $scope.requestData = function() {
            getList();
        };

        // 获取当前登录人的信息 获取token
        function getCurrentInfo() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'getCurrUserInfo'
            };
            $scope.loadingPromise = trsHttpService
                .httpServer(trsHttpService.getWCMRootUrl(), params, 'get', '', {
                    token: token
                })
                .then(function(data) {
                    if (data.TENANTID) {
                        tenantId = data.TENANTID;
                        getToken(deffer.resolve);
                    }
                });
            return deffer.promise;
        }

        // 获取登录token
        function getToken(resolve) {
            var params = {
                serviceid: 'getToken',
                tenantId: tenantId
            };
            $scope.loadingPromise = trsHttpService
                .httpServer(trsHttpService.getWCMRootUrl(), params, 'get', '', {
                    token: token
                })
                .then(function(data) {
                    if (data.token) {
                        token = data.token;
                        resolve();
                    }
                });
        }

        // 判断用户类型 获取token 请求列表
        isTenantAdmin()
            .then(getCurrentInfo)
            .then(getList);

        // 分页 页面跳转
        $scope.jumpToPage = function() {
            getList();
        };

        // 全选
        $scope.selectAll = function() {
            $scope.data.selectedArray =
                $scope.data.selectedArray.length === $scope.data.tenants.length
                    ? []
                    : (function() {
                          var array = [];
                          for (var i = 0; i < $scope.data.tenants.length; i++) {
                              array.push($scope.data.tenants[i]);
                          }
                          return array;
                      })();
        };
        // 勾选
        $scope.selectItem = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(
                    $scope.data.selectedArray.indexOf(item),
                    1
                );
            }
        };

        // 删除
        $scope.deleteHandler = function() {
            if (!$scope.data.selectedArray.length) return;
            modalDialog.confirmModal('删除', '请确认是否要删除', function() {
                var ids = $scope.data.selectedArray
                    .map(item => item.fieldId)
                    .join();
                $scope.loadingPromise = trsHttpService
                    .httpServer(
                        '/api/tenantcenter/fieldhotpot/deleteSeveral',
                        {
                            fieldIds: ids
                        },
                        'post',
                        '',
                        { token: token }
                    )
                    .then(function(data) {
                        if (data.code === '200') {
                            getList();
                        } else {
                            modalDialog.alertType('删除失败!', '', 'error');
                        }
                    });
            });
        };

        // 获取详情
        function getDetail(item) {
            $scope.loadingPromise = trsHttpService
                .httpServer(
                    '/api/tenantcenter/fieldhotpot/findOneByDetail',
                    {
                        fieldId: item.fieldId
                    },
                    'post',
                    '',
                    { token: token }
                )
                .then(function(data) {
                    console.log(data);
                });
        }

        // 查看详情
        $scope.showDetail = function(item) {
            openModel([token, item, true]);
        };

        // 编辑
        $scope.editTenant = function(item) {
            openModel([token, item], getList);
        };

        // 新增
        $scope.addFn = function() {
            openModel([token], getList);
        };

        // 打开弹框
        function openModel(option, fn) {
            tManageMentService.createTerritoryPoint.apply(null, option).then(
                function() {
                    fn && fn();
                },
                function() {
                    //失败
                }
            );
        }

        // 绑定 全部
        // $scope.bindHandler = function() {
        //     modalDialog.confirmModal("", "请确认是否要绑定", function() {
        //         var ids = $scope.data.selectedArray.map(item => item.fieldId).join();
        //         $scope.loadingPromise = trsHttpService.httpServer('/api/tenantcenter/fieldhotpot/bindFieldHot', {
        //             fieldHotIds: ids,
        //             tenantId: tenantId
        //         }, "post", '', {token: token}).then(function(data) {
        //             if (data.code === '200') {
        //                 modalDialog.alertType("绑定成功", "", "success");
        //                 getList();
        //             } else {
        //                 modalDialog.alertType("绑定失败!", "", "error");
        //             }
        //         });
        //     });
        // }
        // 绑定 解绑
        $scope.toggleBind = function(item) {
            var notBind = item.status === 0;
            $scope.loadingPromise = trsHttpService
                .httpServer(
                    '/api/tenantcenter/fieldhotpot/bindFieldHot',
                    {
                        tenantId: tenantId,
                        oprType: notBind ? 1 : 0,
                        fieldHotIds: item.fieldId
                    },
                    'post',
                    '',
                    { token: token }
                )
                .then(function(data) {
                    if (data.code === '200') {
                        item.status = notBind ? 1 : 0;
                    } else {
                        modalDialog.alertType('操作失败!', '', 'error');
                    }
                });
        };
    }
]);
